import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CustomUserDocumentTemplate from 'invite-sign/models/custom-user-document-template';

export type DocumentUploadRequirementStatus =
  | 'pending_upload'
  | 'pending_finalize'
  | 'pending_review'
  | 'fulfilled'
  | 'expired';

export default class DocumentUploadRequirement extends Model {
  declare [Type]: 'document-upload-requirement';

  @belongsTo('custom-user-document-template', { async: false, inverse: null })
  declare userDocumentTemplate: CustomUserDocumentTemplate;

  @attr('string') declare status: DocumentUploadRequirementStatus;
  @attr('string') declare uploadLink: string | null;
  @attr('string') declare documentId: string | null;
  @attr('string') declare templateTitle: string | null;
  @attr('string') declare templateDescription: string | null;
}
